import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError, tap } from 'rxjs';
import { AppConfigService } from './base/app-config.service';
import { RepumpCounter, TLRDataModel } from '../models/tlrDataModel';

@Injectable({
  providedIn: 'root'
})
export class OperatorService {
  apiBaseUrl = `${AppConfigService.settings.apiUrl}`;


  constructor(private http: HttpClient) {
  }

  /**
   * Gets the current facility ID from localStorage or returns default 'ES'
   */
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }

  /**
   * Gets the current user CAI from localStorage or returns default 'qwlx'
   */
  getCurrentUserCai(): string {
    return localStorage.getItem('current_user_cai') || 'qwlx';
  }

  getOperationByTagNumber(tagNumber: any): Observable<any> {
    const facilityId = this.getCurrentFacilityId();
    return this.http.get(`${this.apiBaseUrl}Operator/GetOperationByTagNumber?facilityId=${facilityId}&tagNumber=${tagNumber}`,
      { observe: 'response' }
    ).pipe(
      catchError(error => {
        return of(error);
      })
    );
  }

  AddOrUpdateTLRInstallationInfo(payload: any): Observable<any> {
    const email = sessionStorage.getItem('currentUser') || '';
    // Ensure the payload has facilityID and modifiedByCAI
    const enhancedPayload = {
      ...payload,
      facilityID: this.getCurrentFacilityId(),
      modifiedByCAI: email,
      dateModified: new Date().toISOString()
    };
    return this.http.post(`${this.apiBaseUrl}Operator/AddOrUpdateTLRInstallationInfo`, enhancedPayload, {
      responseType: 'text'
    });
  }


  GetOperatorListView(): Observable<any> {
    return this.http.get(`${this.apiBaseUrl}Operator/GetOperatorList?facilityId=${this.getCurrentFacilityId()}`).pipe(
      catchError(error => {
        return of(null);
      })
    );
  }

  deleteOperatorTag(tagNumber: string): Observable<any> {
    return this.http.delete(`${this.apiBaseUrl}Operator/DeleteOperation?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`).pipe(
      catchError(error => {
        return of({ success: false, error: error.message || 'Delete failed' });
      })
    );
  }

  getOperatorTLRData(tagNumber: string): any {
    return this.http.get<TLRDataModel>(`${this.apiBaseUrl}Operator/GetOperatorTLRData?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
  getRepumpCounter(tagNumber: string): any {
    return this.http.get<number>(`${this.apiBaseUrl}Operator/GetRePumpCounter?facilityId=${this.getCurrentFacilityId()}&tagNumber=${tagNumber}`).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
  updateRepumpCounter(repumpData: RepumpCounter): Observable<any> {
    return this.http.post(`${this.apiBaseUrl}Operator/UpdateRePumpCounter`, repumpData, {
      responseType: 'text' // Specify that we expect a text response
    }).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  getDropdonwList(): any {
    return this.http.get<number>(`${this.apiBaseUrl}Operator/GetOperatorDropdonwList?facilityId=${this.getCurrentFacilityId()}`).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }
  addTLRData(tlrData: TLRDataModel): any {
    return this.http.post(`${this.apiBaseUrl}Operator/AddTLRData`, tlrData, { 
      responseType: 'text' 
    }).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  updateTLRData(tlrData: TLRDataModel): any {
    return this.http.post(`${this.apiBaseUrl}Operator/UpdateTLRData`, tlrData, { 
      responseType: 'text' 
    }).pipe(
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

}

